<template>
    <div
      class="filterRow"
      v-bind:class="{
        frontend_hidden: this.tags ? !this.tags.length : true,
        frontend_tags: this.$props.show_filter,
        overlay_filter: this.displayMode == 'overlay' && this.tags.length,
      }"
    >
      <div class="frontend-hidden searchFilter">
        <input
          type="text"
          v-model="searchNames"
          placeholder="search"
          class="form-control"
        />
      </div>
      <div class="frontend-hidden">
        <div>
          <div class="startDateFilter">
            <input
              type="date"
              v-model="startDate"
              placeholder="date start"
              class="form-control"
            />
          </div>
          <div class="endDateFilter">
            <input
              type="date"
              v-model="endDate"
              placeholder="date end"
              class="form-control"
            />
          </div>
        </div>
      </div>
      <div class="frontend-hidden uploaderFilter" >
        <div class>
          <v-select
            label="name"
            :options="uploader"
            v-model="selected"
            placeholder="select uploader"
          ></v-select>
        </div>
        <div class>
          <v-select
            label="mime_type"
            :options="types"
            v-model="selectedType"
            placeholder="type"
          ></v-select>
        </div>
      </div>
      <div class="tag-column" v-if="this.tags.length">
        <v-select
          multiple
          label="text"
          :options="this.tags"
          v-model="selectedTag"
          :placeholder="trans('lms.SelectTag')"
          :close-on-select="false"
          :clearable="true"
        >
          <div slot="no-options">{{ trans("lms.NoMatchingTags") }}</div>
        </v-select>
      </div>

      <div
        class="filter-buttons"
        v-if="this.filterFrontend && this.tags.length"
        v-bind:class="{ 'col-md-4': this.tags.length }"
      >
        <button
          class="btn btn-primary positive"
          id="filterFile"
          @click="filterFiles(startDate, endDate, selectedType, selectedTag, selected)"
        >
          {{ trans("lms.Filter") }}
        </button>
        <button
          class="btn btn-default neutral resetFilterButton"
          @click="resetFilter()"
        >
          {{ trans("lms.Reset") }}
        </button>
      </div>
    </div>
</template>
<script>
    import Bus from "../bus";
    export default {
        props: ['tags', 'displayMode', 'filterFrontend'],
        data(){
            return {
                startDate: null,
                endDate: null,
                searchNames: '',
                selected: null,
                selectedType: null,
                selectedTag: null,
                uploader: [],
                types: [
                    { typeName: "image/png", mime_type: "png" },
                    { typeName: "application/pdf", mime_type: "pdf" },
                    { typeName: "application/vnd.ms-powerpoint", mime_type: "ppt" },
                    { typeName: "text/plain", mime_type: "csv" },
                    { typeName: "image/jpg", mime_type: "jpg" },
                    { typeName: "image/jpeg", mime_type: "jpeg" },
                    {
                        typeName:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        mime_type: "xls",
                    },
                    { typeName: "video/mp4", mime_type: "mp4" },
                ],
            }
        },
        mounted(){
            axios.get("/media/uploader").then((response) => {
                this.uploader = response.data;
            });
        },
        methods: {
            filterFiles(start, end, type, tags, uploader) {
                let uri, model_id, media_type;

                uri = "/media/filter";
                model_id = localStorage.getItem("current_model_id") || localStorage.getItem("media_id");
                media_type = localStorage.getItem("media_type");

                self.loading = true;
                axios.post(uri, {
                        startDate: start,
                        endDate: end,
                        type: type,
                        tags: tags,
                        uploader: uploader,
                        model_id: model_id,
                        media_type: media_type,
                        _token: this.csrf
                    })
                    .then(function (response) {
                        self.loading = false;
                        Bus.$emit("filters", response.data);
                    }
                );
            },
            resetFilter() {
                this.startDate = null,
                this.endDate = null,
                this.selectedType = null,
                this.selectedTag = null,
                this.selected = null,
                this.filterFiles(null, null, null, null, null);
            },
        }
    }
</script>
<style scoped lang="scss">


</style>


// WEBPACK FOOTER //
// resources/assets/js/components/filters.vue